import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// material-ui
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = { PaperProps: { style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 200 } } };

// ==============================|| SELECT COLUMN VISIBILITY ||============================== //

export default function SelectColumnVisibility({
  getVisibleLeafColumns,
  getIsAllColumnsVisible,
  getToggleAllColumnsVisibilityHandler,
  getAllColumns
}) {
  const intl = useIntl();
  return (
    <FormControl sx={{ width: 200 }}>
      <Select
        id="column-hiding"
        multiple
        displayEmpty
        value={getVisibleLeafColumns().map((col) => col.id)}
        input={<OutlinedInput id="select-column-hiding" placeholder={intl.formatMessage({ id: 'table.selectColumn' })} />}
        renderValue={() => {
          if (getIsAllColumnsVisible()) {
            return <Typography variant="subtitle1">{intl.formatMessage({ id: 'table.allColumnsVisible' })}</Typography>;
          }

          if (getVisibleLeafColumns().length === 0) {
            return <Typography variant="subtitle1">{intl.formatMessage({ id: 'table.allColumnsHidden' })}</Typography>;
          }

          return <Typography variant="subtitle1">{intl.formatMessage({ id: 'table.columnsVisible' }, { count: getVisibleLeafColumns().length })}</Typography>;
        }}
        MenuProps={MenuProps}
        size="small"
      >
        <MenuItem value="all" onClick={getToggleAllColumnsVisibilityHandler()}>
          <Checkbox checked={getIsAllColumnsVisible()} color="success" />
          <ListItemText primary={intl.formatMessage({ id: 'table.allColumns' })} />
        </MenuItem>
        {getAllColumns().map(
          (column) =>
            column.id && (
              <MenuItem
                key={column.id}
                value={column.id}
                onClick={column.getToggleVisibilityHandler()}
                sx={{ '&.Mui-selected': { bgcolor: 'transparent' } }}
              >
                <Checkbox checked={column.getIsVisible()} color="success" />
                <ListItemText primary={column.columnDef.header} />
              </MenuItem>
            )
        )}
      </Select>
    </FormControl>
  );
}

SelectColumnVisibility.propTypes = {
  getVisibleLeafColumns: PropTypes.func,
  getIsAllColumnsVisible: PropTypes.func,
  getToggleAllColumnsVisibilityHandler: PropTypes.func,
  getAllColumns: PropTypes.func
};
